<template>
  <div class="c-knowledge">

    <!--测评概览-->
    <knowledge-overview :overviewData="basicInfo"
    :classType="classType" v-bind="$attrs"/>
    <div class="c-knowledge__distribute">
      <div class="distribute-left">
        <div class="distribute-left__num">02</div>
        <div class="distribute-left__title">知识点掌握程度细分</div>
      </div>
      <div class="distribute-right">
        <div v-show="selectedLen>0"
          class="distribute-right__selected">已选择<span class="blue">{{selectedLen}}</span>
          个知识点
        </div>
        <div class="distribute-right__cancel">
          <el-button class="cancel-btn" v-show="selectedLen>0"
          @click="handleCancel">取消</el-button>
        </div>
        <div class="distribute-right__layout">
          <!--处理禁用属性样式，如果直接设置disabled则不能用hover,须自己判断处理-->
          <el-tooltip effect="dark" content="请勾选需要布置的知识点" placement="top" v-if="isDisabled">
            <el-button type="primary" icon="el-icon-plus"
            @click="doExercises"
            :class="isDisabled?'tooltip-hover':''" >
              布置知识点巩固练习
            </el-button>
          </el-tooltip>
          <el-button type="primary" icon="el-icon-plus" v-else
            @click="doExercises">
              布置知识点巩固练习
          </el-button>
        </div>
      </div>
    </div>

    <ul class="c-knowledge__detail">
      <li class="detail-item" v-for="(item,index) in knowledgeTypeList"
      :key="`type_${index}`" :class="activeIndex===index?'active':''"
      @click="changeItem(index)">
        <div class="detail-item__num">
          <div class="num-left" :class="item.num<1?'zero':''">{{item.num}}</div>
          <div class="num-right" :class="activeIndex===index?'active':''">
            <span>{{item.totalNum}}</span>
            <span class="num-right__num">个</span>
          </div>
        </div>
        <div class="item-type" :class="activeIndex===index?'active':''">
          {{item.typeName}}
        </div>
        <div class="item-text" :class="activeIndex===index?'active':''">
          {{item.typeDetail}}
        </div>
      </li>
    </ul>

    <div class="c-knowledge__table">
      <!-- 此处有坑动态绑定ref不能用字符串模版拼接,则用发射器获取-->
      <knowledge-table :tableList="changeData(item)" ref="level"
        v-for="(item,index) in levelNum" :key="`knowledge_${index}`"
        :tableName="showNameList" :activeIndex='item'
        :knowledgeList="knowledgeTypeList"
        :basicInfo = basicInfo @getLevelZero="getZeroList"
        @getLevelOne="getOneList" @getLevelTwo="getTwoList"
        @getLevelThree="getThreeList" @getLevelFour="getFourList"
        v-show='activeIndex==item' />
    </div>

    <knowledge-dialog
      :dialogVisible="dialogVisible"
      @handleClose ="handleGoArrange"
      @handleClean="handleNoArrange"
    />
  </div>
</template>

<script>
import storeCreator from '@/utils/store-creator';
import KnowledgeTable from './knowledge-table.vue';
import KnowledgeOverview from './knowledge-overview.vue';
import KnowledgeDialog from './knowledge-dialog.vue';
import { getCodeList } from '../../../api/pt';

const CLASS_TYPE = 1; // 1.表示班级报告 2.表示班级对比报告
export default {
  name: 'KnowledgeDetail',
  components: {
    KnowledgeTable,
    KnowledgeOverview,
    KnowledgeDialog,
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {},
    },
    changeInfo: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    basicInfo(v) {
      this.knowledgeTypeList.forEach((item, index) => {
        this.knowledgeTypeList[index].totalNum = v.score_distribution[`level_${index + 1}`];
      });
      if (!v.distribution_key) this.activeIndex = 0;
      this.activeIndex = v.distribution_key
      && Number(v.distribution_key.substring(6, 7)) - 1;
      this[`levelData${this.activeIndex}`] = v.code_list;
      // 首次获取到的显示table，不让再次调用接口
      this[`is${this.resToEnglish[this.activeIndex]}InterFace`] = false;
      this[`isChange${this.resToEnglish[this.activeIndex]}InterFace`] = false;
    },
  },
  data() {
    const tdWidth = 120;
    return {
      classType: CLASS_TYPE,
      resToEnglish: {
        0: 'One',
        1: 'Two',
        2: 'Three',
        3: 'Four',
        4: 'Five',
      },
      levelNum: [0, 1, 2, 3, 4],
      detailInfo: {},
      dialogVisible: false,
      visible: false,
      activeIndex: 0,
      knowledgeTypeList: [
        {
          num: 0, totalNum: '', typeName: '未掌握(0-19%)', typeDetail: '呈现劣势的知识点',
        },
        {
          num: 0, totalNum: '', typeName: '掌握较弱(20-39%)', typeDetail: '需要继续加强学习的知识点',
        },
        {
          num: 0, totalNum: '', typeName: '掌握一般(40-59%)', typeDetail: '需要进一步提升的知识点',
        },
        {
          num: 0, totalNum: '', typeName: '掌握较好(60-79%)', typeDetail: '需要加强拓展的知识点',
        },
        {
          num: 0, totalNum: '', typeName: '掌握熟练(80-100%)', typeDetail: '图层呈现优势的知识点',
        },
      ],
      levelData0: [],
      levelData1: [],
      levelData2: [],
      levelData3: [],
      levelData4: [],
      tableNameList: [
        {
          label: '知识点id',
          prop: 'tag_code',
          width: tdWidth,
          show: false,
        },
        {
          label: '知识点名字',
          prop: 'tag_name',
          width: tdWidth,
          show: true,
        },
        {
          label: '班级掌握程度',
          prop: 'avg_score',
          width: tdWidth,
          show: true,
          sortable: true,
        },
        {
          label: '正答率',
          prop: 'avg_right_rate',
          width: tdWidth,
          show: true,
          sortable: true,
        },
        {
          label: '班级未掌握人数',
          prop: 'low_score_count',
          width: tdWidth,
          show: true,
          sortable: true,
        },
      ],
      selectedList: [],
      isOneInterFace: true,
      isTwoInterFace: true,
      isThreeInterFace: true,
      isFourInterFace: true,
      isFiveInterFace: true,
      isChangeOneInterFace: true,
      isChangeTwoInterFace: true,
      isChangeThreeInterFace: true,
      isChangeFourInterFace: true,
      isChangeFiveInterFace: true,
      sLevelOne: [],
      sLevelTwo: [],
      sLevelThree: [],
      sLevelFour: [],
      sLevelFive: [],
    };
  },
  computed: {
    showNameList() {
      return this.tableNameList.filter((item) => item.show);
    },
    selectedLen() {
      let selected = 0;
      this.knowledgeTypeList.forEach((item) => {
        selected += item.num;
      });
      return selected;
    },
    isDisabled() {
      return !(this.selectedLen > 0);
    },
  },
  methods: {
    changeData(index) {
      return this[`levelData${index}`];
    },
    getZeroList(data) {
      this.sLevelOne = data;
    },
    getOneList(data) {
      this.sLevelTwo = data;
    },
    getTwoList(data) {
      this.sLevelThree = data;
    },
    getThreeList(data) {
      this.sLevelFour = data;
    },
    getFourList(data) {
      this.sLevelFive = data;
    },
    doExercises() {
      this.selectedList = [
        ...this.sLevelOne,
        ...this.sLevelTwo,
        ...this.sLevelThree,
        ...this.sLevelFour,
        ...this.sLevelFive,
      ];
      // 选择处理
      if (!this.selectedList.length) {
        return;
      }
      // 最大选中20条
      if (this.selectedList.length > 20) {
        this.$message({
          type: 'warning',
          message: '一次最多选择20个知识点',
        });
        return;
      }
      // 避免url长度问题
      const store = storeCreator.create('pt');
      store.set('selectedList', JSON.stringify(this.selectedList));

      this.$router.push({
        path: '/pt/create-weakspot',
        query: {
          subjectId: this.basicInfo.subject_id,
          subjectName: this.basicInfo.subject_name,
          className: this.basicInfo.class_name,
          testId: this.basicInfo.test_id,
          testName: this.basicInfo.test_name,
          classId: this.basicInfo.class_id,
        },
      });
    },
    changeItem(index) {
      this.activeIndex = index;
      if (Object.keys(this.changeInfo).length) {
        if ((index === 0 && this.isChangeOneInterFace)
        || (index === 1 && this.isChangeTwoInterFace)
        || (index === 2 && this.isChangeThreeInterFace)
        || (index === 3 && this.isChangeFourInterFace)
        || (index === 4 && this.isChangeFiveInterFace)) {
          this.getCodeList(index, this.changeInfo);
        }
      } else if ((index === 0 && this.isOneInterFace)
        || (index === 1 && this.isTwoInterFace)
        || (index === 2 && this.isThreeInterFace)
        || (index === 3 && this.isFourInterFace)
        || (index === 4 && this.isFiveInterFace)
      ) this.getCodeList(index, {});
    },
    getCodeList(index, data) {
      const { evaluateId, schoolId, classId } = this.$route.query;
      return getCodeList({
        school_id: schoolId,
        class_id: data.class_id ? data.class_id : classId,
        evaluate_id: data.evaluate_id ? data.evaluate_id : evaluateId,
        level: index + 1,
      }).then((res) => {
        if (res.code === 200) {
          if (data.class_id) {
            if (index === 0) this.isChangeOneInterFace = false;
            if (index === 1) this.isChangeTwoInterFace = false;
            if (index === 2) this.isChangeThreeInterFace = false;
            if (index === 3) this.isChangeFourInterFace = false;
            if (index === 4) this.isChangeFiveInterFace = false;
          } else {
            if (index === 0) this.isOneInterFace = false;
            if (index === 1) this.isTwoInterFace = false;
            if (index === 2) this.isThreeInterFace = false;
            if (index === 3) this.isFourInterFace = false;
            if (index === 4) this.isFiveInterFace = false;
          }
          this[`levelData${index}`] = res.data;
          // 班级 掌握程度正序
          this[`levelData${index}`].sort(this.compareSort('avg_score'));
        }
      }).catch((error) => {
        console.log('error', error);
      });
    },
    // 正序排列
    compareSort(data) {
      return (a, b) => {
        const sortA = a[data];
        const sortB = b[data];
        return sortA - sortB;
      };
    },
    handleCancel() {
      this.dialogVisible = true;
    },
    // 不再布置
    handleNoArrange() {
      // 清空所有选中数据
      this.dialogVisible = false;
      this.selectedList = [];
      this.knowledgeTypeList.forEach((item, index) => {
        this.knowledgeTypeList[index].num = 0;
      });
      // 清空所有组件里面的方法
      this.$refs.level.forEach((item, index) => {
        this.$refs.level[index].clearSelected();
      });
    },
    // 继续布置
    handleGoArrange() {
      // 直接关闭
      this.dialogVisible = false;
    },
  },
  mounted() {
  },
  activated() {
    // 返回清除
    this.levelNum.forEach((item, index) => {
      this[`levelData${item}`] = [];
      this[`is${this.resToEnglish[index]}InterFace`] = true;
    });
  },
};
</script>

<style lang="scss" scoped>
.c-knowledge{
  box-sizing: border-box;
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding-bottom: 80px;
  &__distribute{
    display: flex;
    padding:15px 19px 0 19px;
    justify-content: space-between;
    .distribute-left{
      display: flex;
      align-items: center;
      &__num{
        font-size: 22px;

        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        margin-right: 14px;
        background:url('~@/views/pt/images/class_bg.png');
        background-size:cover;
        width:38px;
        height:29px;
        text-align: center;
      }
      &__title{
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
      }
    }
    .distribute-right{
      align-items: center;
      display: flex;
      &__selected{
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        margin-right: 16px;
      }
      .blue{
        color:#1989FA;
      }
      &__cancel{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        margin-right: 16px;
        .cancel-btn{
          width:120px;
          height:40px;
        }
      }
      &__layout{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        /deep/ .el-button--primary.is-disabled{
          color: #FFF;
          background-color: rgba(17, 31, 44, 0.12);
          border-color:#fff;
        }
        .tooltip-hover{
          cursor: not-allowed;
          color: #FFF;
          background-color: rgba(17, 31, 44, 0.12);
          border-color:#fff;
        }
      }
    }
  }
  &__detail{
    border-top-left-radius:5px;
    border-top-right-radius:5px;
    border:2px solid #E0E6F3;
    border-bottom:none;
    min-height: 103px;
    margin:22px 20px 0 20px;
    display: flex;
    cursor: pointer;
    .detail-item{
      width: 20%;
      border-radius: 5px;
      padding:10px 24px 0 0;
      position: relative;
      border-right: 1px solid #f0f2f5;
      &:last-child{
        border-right: 0;
      }
      &.active{
        background-color: #2194FF;
        box-shadow: 0px 3px 4px 0px rgba(120, 166, 219, 0.5);
        border-right: 0;
        border-left: 0;
      }
      &__num{
        display: flex;
        justify-content: space-between;
        .num-left{
          width: 34px;
          height: 27px;
          background-color: #F56C6C;
          color: #fff;
          line-height: 27px;
          text-align: center;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          font-size: 20px;
          &.zero{
            visibility: hidden;
          }
        }
        .num-right{
          font-size: 20px;
          color:#1890FF;
          margin-left:5px;
          &__num{
            font-size:15px;
          }
          &.active{
            color:#fff;
          }
        }
      }
      .item-type{
        text-align: right;
        margin-top:7px;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000;
        &.active{
          color: #fff;
        }
      }
      .item-text{
        text-align: right;
        margin-top:8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        &.active{
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }
  &__table{
    margin:0 20px;
    border:1px solid #E0E6F3;
  }
}
</style>
